import { ApiHttpError } from '@/lib/apiHttpError';
import { API_URL } from '@/lib/constants';
import { paths } from '@/types/api';
import { useAuth } from '@workos-inc/authkit-react';
import createFetchClient, { Middleware } from 'openapi-fetch';
import { useMemo } from 'react';

export function useApiFetch() {
  const { isLoading, getAccessToken: workOSGetAccessToken } = useAuth();

  const apiErrorMiddleware: Middleware = useMemo(() => {
    return {
      onResponse: async ({ request, response }) => {
        const err = await ApiHttpError.create(request, response);
        if (err) {
          throw err;
        }
      },
      onError({ error }) {
        return error as Error;
      },
    };
  }, []);

  const apiAuthMiddleware: Middleware = useMemo(() => {
    return {
      onRequest: async ({ request }) => {
        const accessToken = await workOSGetAccessToken();
        request.headers.set('Authorization', `Bearer ${accessToken}`);
        return request;
      },
    };
  }, [workOSGetAccessToken]);

  const apiFetch = useMemo(() => {
    const client = createFetchClient<paths>({ baseUrl: API_URL });
    client.use(apiErrorMiddleware);
    client.use(apiAuthMiddleware);
    return client;
  }, [apiErrorMiddleware, apiAuthMiddleware]);

  return {
    apiFetch,
    isLoading,
  };
}
